/**
 * Where the zip's bytes live.
 *
 * A module-level Map, deliberately — NOT zustand, and never a message field.
 *
 * Every message is `JSON.stringify`d into localStorage on a 400ms debounce with
 * no field whitelist, and `JSON.stringify(new File(...))` is `{}`. So a File
 * parked on a message survives the round-trip looking perfectly intact and
 * completely empty, and a `blob:` URL persisted beside it renders as a broken
 * image after a reload. Messages therefore carry a DESCRIPTOR — counts, names,
 * an id — and the bytes are looked up here by that id.
 *
 * The consequence is deliberate and has to be handled in the UI: after a
 * refresh the vault is empty while the card is still on screen. `hasDataset`
 * is how the card knows to ask for the file again instead of offering a Run
 * button that cannot work.
 */

/**
 * How many archives to keep at once. A zip and its decoded entries can be
 * hundreds of megabytes; holding every one the user ever dragged in would
 * eventually take the tab down.
 */
const MAX_HELD = 3;

const vault = new Map();

export const putDataset = (id, entry) => {
  if (!id) return;
  vault.set(id, entry);
  // Map iterates in insertion order, so the first key is the oldest.
  while (vault.size > MAX_HELD) {
    const oldest = vault.keys().next().value;
    if (oldest === undefined) break;
    vault.delete(oldest);
  }
};

export const getDataset = (id) => (id && vault.get(id)) || null;

export const hasDataset = (id) => !!id && vault.has(id);

export const dropDataset = (id) => vault.delete(id);

export const clearVault = () => vault.clear();

/** Only for assertions — the size is not part of the contract. */
export const vaultSize = () => vault.size;
